// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.32.1
// source: sensor_msgs/msg/BatteryState.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Header } from "../../std_msgs/msg/Header";

export const protobufPackage = "sensor_msgs.msg.pb";

export interface BatteryState {
  header:
    | Header
    | undefined;
  /** Voltage in Volts (Mandatory) */
  voltage: number;
  /** Temperature in Degrees Celsius (If unmeasured NaN) */
  temperature: number;
  /** Negative when discharging (A)  (If unmeasured NaN) */
  current: number;
  /** Current charge in Ah  (If unmeasured NaN) */
  charge: number;
  /** Capacity in Ah (last full capacity)  (If unmeasured NaN) */
  capacity: number;
  /** Capacity in Ah (design capacity)  (If unmeasured NaN) */
  design_capacity: number;
  /** Charge percentage on 0 to 1 range  (If unmeasured NaN) */
  percentage: number;
  /** The charging status as reported. Values defined above */
  power_supply_status: number;
  /** The battery health metric. Values defined above */
  power_supply_health: number;
  /** The battery chemistry. Values defined above */
  power_supply_technology: number;
  /** True if the battery is present */
  present: boolean;
  /**
   * An array of individual cell voltages for each cell in the pack
   * If individual voltages unknown but number of cells known set each to NaN
   */
  cell_voltage: number[];
  /**
   * An array of individual cell temperatures for each cell in the pack
   * If individual temperatures unknown but number of cells known set each to NaN
   */
  cell_temperature: number[];
  /** The location into which the battery is inserted. (slot number or plug) */
  location: string;
  /** The best approximation of the battery serial number */
  serial_number: string;
}

export enum BatteryState_PowerEnum {
  /**
   * POWER_SUPPLY_STATUS_UNKNOWN - Constants are chosen to match the enums in the linux kernel
   * defined in include/linux/power_supply.h as of version 3.7
   * The one difference is for style reasons the constants are
   * all uppercase not mixed case.
   * Power supply status constants
   */
  POWER_SUPPLY_STATUS_UNKNOWN = 0,
  POWER_SUPPLY_STATUS_CHARGING = 1,
  POWER_SUPPLY_STATUS_DISCHARGING = 2,
  POWER_SUPPLY_STATUS_NOT_CHARGING = 3,
  POWER_SUPPLY_STATUS_FULL = 4,
  /** POWER_SUPPLY_HEALTH_UNKNOWN - Power supply health constants */
  POWER_SUPPLY_HEALTH_UNKNOWN = 0,
  POWER_SUPPLY_HEALTH_GOOD = 1,
  POWER_SUPPLY_HEALTH_OVERHEAT = 2,
  POWER_SUPPLY_HEALTH_DEAD = 3,
  POWER_SUPPLY_HEALTH_OVERVOLTAGE = 4,
  POWER_SUPPLY_HEALTH_UNSPEC_FAILURE = 5,
  POWER_SUPPLY_HEALTH_COLD = 6,
  POWER_SUPPLY_HEALTH_WATCHDOG_TIMER_EXPIRE = 7,
  POWER_SUPPLY_HEALTH_SAFETY_TIMER_EXPIRE = 8,
  /** POWER_SUPPLY_TECHNOLOGY_UNKNOWN - Power supply technology (chemistry) constants */
  POWER_SUPPLY_TECHNOLOGY_UNKNOWN = 0,
  POWER_SUPPLY_TECHNOLOGY_NIMH = 1,
  POWER_SUPPLY_TECHNOLOGY_LION = 2,
  POWER_SUPPLY_TECHNOLOGY_LIPO = 3,
  POWER_SUPPLY_TECHNOLOGY_LIFE = 4,
  POWER_SUPPLY_TECHNOLOGY_NICD = 5,
  POWER_SUPPLY_TECHNOLOGY_LIMN = 6,
  UNRECOGNIZED = -1,
}

export function batteryState_PowerEnumFromJSON(object: any): BatteryState_PowerEnum {
  switch (object) {
    case 0:
    case "POWER_SUPPLY_STATUS_UNKNOWN":
      return BatteryState_PowerEnum.POWER_SUPPLY_STATUS_UNKNOWN;
    case 1:
    case "POWER_SUPPLY_STATUS_CHARGING":
      return BatteryState_PowerEnum.POWER_SUPPLY_STATUS_CHARGING;
    case 2:
    case "POWER_SUPPLY_STATUS_DISCHARGING":
      return BatteryState_PowerEnum.POWER_SUPPLY_STATUS_DISCHARGING;
    case 3:
    case "POWER_SUPPLY_STATUS_NOT_CHARGING":
      return BatteryState_PowerEnum.POWER_SUPPLY_STATUS_NOT_CHARGING;
    case 4:
    case "POWER_SUPPLY_STATUS_FULL":
      return BatteryState_PowerEnum.POWER_SUPPLY_STATUS_FULL;
    case 0:
    case "POWER_SUPPLY_HEALTH_UNKNOWN":
      return BatteryState_PowerEnum.POWER_SUPPLY_HEALTH_UNKNOWN;
    case 1:
    case "POWER_SUPPLY_HEALTH_GOOD":
      return BatteryState_PowerEnum.POWER_SUPPLY_HEALTH_GOOD;
    case 2:
    case "POWER_SUPPLY_HEALTH_OVERHEAT":
      return BatteryState_PowerEnum.POWER_SUPPLY_HEALTH_OVERHEAT;
    case 3:
    case "POWER_SUPPLY_HEALTH_DEAD":
      return BatteryState_PowerEnum.POWER_SUPPLY_HEALTH_DEAD;
    case 4:
    case "POWER_SUPPLY_HEALTH_OVERVOLTAGE":
      return BatteryState_PowerEnum.POWER_SUPPLY_HEALTH_OVERVOLTAGE;
    case 5:
    case "POWER_SUPPLY_HEALTH_UNSPEC_FAILURE":
      return BatteryState_PowerEnum.POWER_SUPPLY_HEALTH_UNSPEC_FAILURE;
    case 6:
    case "POWER_SUPPLY_HEALTH_COLD":
      return BatteryState_PowerEnum.POWER_SUPPLY_HEALTH_COLD;
    case 7:
    case "POWER_SUPPLY_HEALTH_WATCHDOG_TIMER_EXPIRE":
      return BatteryState_PowerEnum.POWER_SUPPLY_HEALTH_WATCHDOG_TIMER_EXPIRE;
    case 8:
    case "POWER_SUPPLY_HEALTH_SAFETY_TIMER_EXPIRE":
      return BatteryState_PowerEnum.POWER_SUPPLY_HEALTH_SAFETY_TIMER_EXPIRE;
    case 0:
    case "POWER_SUPPLY_TECHNOLOGY_UNKNOWN":
      return BatteryState_PowerEnum.POWER_SUPPLY_TECHNOLOGY_UNKNOWN;
    case 1:
    case "POWER_SUPPLY_TECHNOLOGY_NIMH":
      return BatteryState_PowerEnum.POWER_SUPPLY_TECHNOLOGY_NIMH;
    case 2:
    case "POWER_SUPPLY_TECHNOLOGY_LION":
      return BatteryState_PowerEnum.POWER_SUPPLY_TECHNOLOGY_LION;
    case 3:
    case "POWER_SUPPLY_TECHNOLOGY_LIPO":
      return BatteryState_PowerEnum.POWER_SUPPLY_TECHNOLOGY_LIPO;
    case 4:
    case "POWER_SUPPLY_TECHNOLOGY_LIFE":
      return BatteryState_PowerEnum.POWER_SUPPLY_TECHNOLOGY_LIFE;
    case 5:
    case "POWER_SUPPLY_TECHNOLOGY_NICD":
      return BatteryState_PowerEnum.POWER_SUPPLY_TECHNOLOGY_NICD;
    case 6:
    case "POWER_SUPPLY_TECHNOLOGY_LIMN":
      return BatteryState_PowerEnum.POWER_SUPPLY_TECHNOLOGY_LIMN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BatteryState_PowerEnum.UNRECOGNIZED;
  }
}

export function batteryState_PowerEnumToJSON(object: BatteryState_PowerEnum): string {
  switch (object) {
    case BatteryState_PowerEnum.POWER_SUPPLY_STATUS_UNKNOWN:
      return "POWER_SUPPLY_STATUS_UNKNOWN";
    case BatteryState_PowerEnum.POWER_SUPPLY_STATUS_CHARGING:
      return "POWER_SUPPLY_STATUS_CHARGING";
    case BatteryState_PowerEnum.POWER_SUPPLY_STATUS_DISCHARGING:
      return "POWER_SUPPLY_STATUS_DISCHARGING";
    case BatteryState_PowerEnum.POWER_SUPPLY_STATUS_NOT_CHARGING:
      return "POWER_SUPPLY_STATUS_NOT_CHARGING";
    case BatteryState_PowerEnum.POWER_SUPPLY_STATUS_FULL:
      return "POWER_SUPPLY_STATUS_FULL";
    case BatteryState_PowerEnum.POWER_SUPPLY_HEALTH_UNKNOWN:
      return "POWER_SUPPLY_HEALTH_UNKNOWN";
    case BatteryState_PowerEnum.POWER_SUPPLY_HEALTH_GOOD:
      return "POWER_SUPPLY_HEALTH_GOOD";
    case BatteryState_PowerEnum.POWER_SUPPLY_HEALTH_OVERHEAT:
      return "POWER_SUPPLY_HEALTH_OVERHEAT";
    case BatteryState_PowerEnum.POWER_SUPPLY_HEALTH_DEAD:
      return "POWER_SUPPLY_HEALTH_DEAD";
    case BatteryState_PowerEnum.POWER_SUPPLY_HEALTH_OVERVOLTAGE:
      return "POWER_SUPPLY_HEALTH_OVERVOLTAGE";
    case BatteryState_PowerEnum.POWER_SUPPLY_HEALTH_UNSPEC_FAILURE:
      return "POWER_SUPPLY_HEALTH_UNSPEC_FAILURE";
    case BatteryState_PowerEnum.POWER_SUPPLY_HEALTH_COLD:
      return "POWER_SUPPLY_HEALTH_COLD";
    case BatteryState_PowerEnum.POWER_SUPPLY_HEALTH_WATCHDOG_TIMER_EXPIRE:
      return "POWER_SUPPLY_HEALTH_WATCHDOG_TIMER_EXPIRE";
    case BatteryState_PowerEnum.POWER_SUPPLY_HEALTH_SAFETY_TIMER_EXPIRE:
      return "POWER_SUPPLY_HEALTH_SAFETY_TIMER_EXPIRE";
    case BatteryState_PowerEnum.POWER_SUPPLY_TECHNOLOGY_UNKNOWN:
      return "POWER_SUPPLY_TECHNOLOGY_UNKNOWN";
    case BatteryState_PowerEnum.POWER_SUPPLY_TECHNOLOGY_NIMH:
      return "POWER_SUPPLY_TECHNOLOGY_NIMH";
    case BatteryState_PowerEnum.POWER_SUPPLY_TECHNOLOGY_LION:
      return "POWER_SUPPLY_TECHNOLOGY_LION";
    case BatteryState_PowerEnum.POWER_SUPPLY_TECHNOLOGY_LIPO:
      return "POWER_SUPPLY_TECHNOLOGY_LIPO";
    case BatteryState_PowerEnum.POWER_SUPPLY_TECHNOLOGY_LIFE:
      return "POWER_SUPPLY_TECHNOLOGY_LIFE";
    case BatteryState_PowerEnum.POWER_SUPPLY_TECHNOLOGY_NICD:
      return "POWER_SUPPLY_TECHNOLOGY_NICD";
    case BatteryState_PowerEnum.POWER_SUPPLY_TECHNOLOGY_LIMN:
      return "POWER_SUPPLY_TECHNOLOGY_LIMN";
    case BatteryState_PowerEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseBatteryState(): BatteryState {
  return {
    header: undefined,
    voltage: 0,
    temperature: 0,
    current: 0,
    charge: 0,
    capacity: 0,
    design_capacity: 0,
    percentage: 0,
    power_supply_status: 0,
    power_supply_health: 0,
    power_supply_technology: 0,
    present: false,
    cell_voltage: [],
    cell_temperature: [],
    location: "",
    serial_number: "",
  };
}

export const BatteryState: MessageFns<BatteryState> = {
  encode(message: BatteryState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(1939194666).fork()).join();
    }
    if (message.voltage !== 0) {
      writer.uint32(1824996741).float(message.voltage);
    }
    if (message.temperature !== 0) {
      writer.uint32(4067561237).float(message.temperature);
    }
    if (message.current !== 0) {
      writer.uint32(3885661013).float(message.current);
    }
    if (message.charge !== 0) {
      writer.uint32(2875031421).float(message.charge);
    }
    if (message.capacity !== 0) {
      writer.uint32(2940618581).float(message.capacity);
    }
    if (message.design_capacity !== 0) {
      writer.uint32(1985418933).float(message.design_capacity);
    }
    if (message.percentage !== 0) {
      writer.uint32(2556075613).float(message.percentage);
    }
    if (message.power_supply_status !== 0) {
      writer.uint32(1964249216).uint32(message.power_supply_status);
    }
    if (message.power_supply_health !== 0) {
      writer.uint32(3686892304).uint32(message.power_supply_health);
    }
    if (message.power_supply_technology !== 0) {
      writer.uint32(1895178816).uint32(message.power_supply_technology);
    }
    if (message.present !== false) {
      writer.uint32(3991300856).bool(message.present);
    }
    writer.uint32(1193330850).fork();
    for (const v of message.cell_voltage) {
      writer.float(v);
    }
    writer.join();
    writer.uint32(644190002).fork();
    for (const v of message.cell_temperature) {
      writer.float(v);
    }
    writer.join();
    if (message.location !== "") {
      writer.uint32(4109675570).string(message.location);
    }
    if (message.serial_number !== "") {
      writer.uint32(1822725722).string(message.serial_number);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BatteryState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBatteryState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 242399333: {
          if (tag !== 1939194666) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 228124592: {
          if (tag !== 1824996741) {
            break;
          }

          message.voltage = reader.float();
          continue;
        }
        case 508445154: {
          if (tag !== 4067561237) {
            break;
          }

          message.temperature = reader.float();
          continue;
        }
        case 485707626: {
          if (tag !== 3885661013) {
            break;
          }

          message.current = reader.float();
          continue;
        }
        case 359378927: {
          if (tag !== 2875031421) {
            break;
          }

          message.charge = reader.float();
          continue;
        }
        case 367577322: {
          if (tag !== 2940618581) {
            break;
          }

          message.capacity = reader.float();
          continue;
        }
        case 248177366: {
          if (tag !== 1985418933) {
            break;
          }

          message.design_capacity = reader.float();
          continue;
        }
        case 319509451: {
          if (tag !== 2556075613) {
            break;
          }

          message.percentage = reader.float();
          continue;
        }
        case 245531152: {
          if (tag !== 1964249216) {
            break;
          }

          message.power_supply_status = reader.uint32();
          continue;
        }
        case 460861538: {
          if (tag !== 3686892304) {
            break;
          }

          message.power_supply_health = reader.uint32();
          continue;
        }
        case 236897352: {
          if (tag !== 1895178816) {
            break;
          }

          message.power_supply_technology = reader.uint32();
          continue;
        }
        case 498912607: {
          if (tag !== 3991300856) {
            break;
          }

          message.present = reader.bool();
          continue;
        }
        case 149166356: {
          if (tag === 1193330853) {
            message.cell_voltage.push(reader.float());

            continue;
          }

          if (tag === 1193330850) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.cell_voltage.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 80523750: {
          if (tag === 644190005) {
            message.cell_temperature.push(reader.float());

            continue;
          }

          if (tag === 644190002) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.cell_temperature.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 513709446: {
          if (tag !== 4109675570) {
            break;
          }

          message.location = reader.string();
          continue;
        }
        case 227840715: {
          if (tag !== 1822725722) {
            break;
          }

          message.serial_number = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BatteryState {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      voltage: isSet(object.voltage) ? globalThis.Number(object.voltage) : 0,
      temperature: isSet(object.temperature) ? globalThis.Number(object.temperature) : 0,
      current: isSet(object.current) ? globalThis.Number(object.current) : 0,
      charge: isSet(object.charge) ? globalThis.Number(object.charge) : 0,
      capacity: isSet(object.capacity) ? globalThis.Number(object.capacity) : 0,
      design_capacity: isSet(object.designCapacity)
        ? globalThis.Number(object.designCapacity)
        : isSet(object.design_capacity)
        ? globalThis.Number(object.design_capacity)
        : 0,
      percentage: isSet(object.percentage) ? globalThis.Number(object.percentage) : 0,
      power_supply_status: isSet(object.powerSupplyStatus)
        ? globalThis.Number(object.powerSupplyStatus)
        : isSet(object.power_supply_status)
        ? globalThis.Number(object.power_supply_status)
        : 0,
      power_supply_health: isSet(object.powerSupplyHealth)
        ? globalThis.Number(object.powerSupplyHealth)
        : isSet(object.power_supply_health)
        ? globalThis.Number(object.power_supply_health)
        : 0,
      power_supply_technology: isSet(object.powerSupplyTechnology)
        ? globalThis.Number(object.powerSupplyTechnology)
        : isSet(object.power_supply_technology)
        ? globalThis.Number(object.power_supply_technology)
        : 0,
      present: isSet(object.present) ? globalThis.Boolean(object.present) : false,
      cell_voltage: globalThis.Array.isArray(object?.cellVoltage)
        ? object.cellVoltage.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.cell_voltage)
        ? object.cell_voltage.map((e: any) => globalThis.Number(e))
        : [],
      cell_temperature: globalThis.Array.isArray(object?.cellTemperature)
        ? object.cellTemperature.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.cell_temperature)
        ? object.cell_temperature.map((e: any) => globalThis.Number(e))
        : [],
      location: isSet(object.location) ? globalThis.String(object.location) : "",
      serial_number: isSet(object.serialNumber)
        ? globalThis.String(object.serialNumber)
        : isSet(object.serial_number)
        ? globalThis.String(object.serial_number)
        : "",
    };
  },

  toJSON(message: BatteryState): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.voltage !== 0) {
      obj.voltage = message.voltage;
    }
    if (message.temperature !== 0) {
      obj.temperature = message.temperature;
    }
    if (message.current !== 0) {
      obj.current = message.current;
    }
    if (message.charge !== 0) {
      obj.charge = message.charge;
    }
    if (message.capacity !== 0) {
      obj.capacity = message.capacity;
    }
    if (message.design_capacity !== 0) {
      obj.designCapacity = message.design_capacity;
    }
    if (message.percentage !== 0) {
      obj.percentage = message.percentage;
    }
    if (message.power_supply_status !== 0) {
      obj.powerSupplyStatus = Math.round(message.power_supply_status);
    }
    if (message.power_supply_health !== 0) {
      obj.powerSupplyHealth = Math.round(message.power_supply_health);
    }
    if (message.power_supply_technology !== 0) {
      obj.powerSupplyTechnology = Math.round(message.power_supply_technology);
    }
    if (message.present !== false) {
      obj.present = message.present;
    }
    if (message.cell_voltage?.length) {
      obj.cellVoltage = message.cell_voltage;
    }
    if (message.cell_temperature?.length) {
      obj.cellTemperature = message.cell_temperature;
    }
    if (message.location !== "") {
      obj.location = message.location;
    }
    if (message.serial_number !== "") {
      obj.serialNumber = message.serial_number;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BatteryState>, I>>(base?: I): BatteryState {
    return BatteryState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BatteryState>, I>>(object: I): BatteryState {
    const message = createBaseBatteryState();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.voltage = object.voltage ?? 0;
    message.temperature = object.temperature ?? 0;
    message.current = object.current ?? 0;
    message.charge = object.charge ?? 0;
    message.capacity = object.capacity ?? 0;
    message.design_capacity = object.design_capacity ?? 0;
    message.percentage = object.percentage ?? 0;
    message.power_supply_status = object.power_supply_status ?? 0;
    message.power_supply_health = object.power_supply_health ?? 0;
    message.power_supply_technology = object.power_supply_technology ?? 0;
    message.present = object.present ?? false;
    message.cell_voltage = object.cell_voltage?.map((e) => e) || [];
    message.cell_temperature = object.cell_temperature?.map((e) => e) || [];
    message.location = object.location ?? "";
    message.serial_number = object.serial_number ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
